import React from 'react'

export default function AccountProfile() {

    return (
    <p>Account Profile</p>
    );
}